module.exports = __webpack_public_path__ + "img/nexultra-l-brush-active-icon.d41b14ff.svg";